import React, { useState, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import Draggable from "react-draggable";
import { CloseOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";
import { loadPage } from "../OrdersSlice";
import { loadRecord } from "../../patientDetails/patientDetailsSlice";
import { useParams, useLocation } from "react-router-dom";
import { Modal, Button, Typography } from "antd";
import { DatePicker } from "../../../components/antOverrides";
import moment from "moment";
import {
  commitChanges,
  setChangedFormItems,
  reset,
} from "../../orderDetails/OrderDetailsSlice";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";

const { Title } = Typography;
const EndOrderModal = (props) => {
  const { record, onHide, visible, activePatient } = props;
  const [endDate, setEndDate] = useState(null);
  const [reason, setReason] = useState(null);
  const [disabled, setDisabled] = useState(true);
  let { branchId } = useParams();
  let location = useLocation();
  const dispatch = useDispatch();
  const updateLoading = useSelector(
    (state) => state.pendingActions["orderDetails/commitChanges"]
  );
  const intl = useIntl();
  const onCancel = () => {
    onHide();
    dispatch(reset());
  };

  useEffect(() => {
    let changed = [];
    let values = {};

    if (endDate) {
      changed.push("effective_to");
      values["effective_to"] = moment.utc(endDate).format();
    }
    if (reason) {
      changed.push("order_close_reason_id");
      values["order_close_reason_id"] = reason;
    }
    dispatch(
      setChangedFormItems({
        changed,
        values,
      })
    );
  }, [endDate, reason]);

  const onEndChanged = (val) => {
    setEndDate(val);
  };

  const onReasonChange = (value) => {
    setReason(value);
  };

  const dateFormat = "DD/MM/YY";
  const disabledEndDate = (current) => {
    return current && record && current < moment(record.effective_from);
  };

  const onSubmit = async () => {
    const action = await dispatch(commitChanges());
    if (!action.error) {
      onHide();
      dispatch(reset());
      dispatch(loadPage({ current: 1 }));
      const isAdmin = location.pathname.includes("admin");
      const params = {
        id: activePatient.id,
        branchId: branchId,
        admin: isAdmin,
      };
      dispatch(loadRecord(params));
    }
  };

  const onMouseOver = () => {
    setDisabled(false);
  };

  const onMouseOut = () => {
    setDisabled(true);
  };

  const filters = record?.order_close_reason_id
    ? [{ active: true }, { id: record?.order_close_reason_id }]
    : [{ active: true }];

  const activeCloseReasonFilter = {
    $and: [
      {
        $or: filters,
      },
    ],
  };

  return (
    <Modal
      closable={false}
      footer={null}
      maskClosable={false}
      title={null}
      width={"600px"}
      styles={{
        body: {
          padding: 0,
        },
      }}
      open={visible}
      destroyOnClose={true}
      modalRender={(modal) => (
        <Draggable disabled={disabled}>{modal}</Draggable>
      )}
    >
      <div>
        <div
          style={{
            width: "100%",
            cursor: "move",
            height: "50px",
            position: "absolute",
            left: "0",
            top: "0",
          }}
          className="header"
          onMouseOver={onMouseOver}
          onMouseOut={onMouseOut}
        >
          <Button
            style={{ position: "absolute", left: 10, top: 10 }}
            className="closeBtn"
            type="text"
            shape="circle"
            icon={<CloseOutlined />}
            onClick={onCancel}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            padding: "40px 40px 40px 40px",
          }}
        >
          <Title
            style={{
              fontSize: "30px",
              fontWeight: 500,
              lineHeight: 1.27,
              color: "rgba(0, 0, 0, 0.85)",
              margin: "13px 0 40px 0 ",
              textAlign: "center",
            }}
          >
            {<FormattedMessage id="app.orders.endOrder" />}
          </Title>
          <div
            style={{ display: "flex", flexDirection: "column", width: "200px" }}
          >
            <DatePicker
              disabledDate={disabledEndDate}
              format={dateFormat}
              onChange={onEndChanged}
              required={true}
            />
            <div style={{ height: "10px" }} />
            <SettingsDataSelect
              name="order_close_reason_id"
              category="order"
              settingsdataName={"system_tables/order_close_reason"}
              onChange={onReasonChange}
              placeholder={intl.formatMessage({
                id: "app.forms.order.order_close_reason_id",
              })}
              extraParams={{
                filter: activeCloseReasonFilter,
              }}
              required={true}
              hideLabel={true}
              type="list"
            />
          </div>

          <Button
            loading={updateLoading}
            onClick={onSubmit}
            style={{ marginTop: "40px" }}
            type="primary"
            disabled={endDate === null || reason === null || reason === ""}
          >
            {<FormattedMessage id="app.actions.endOrder" />}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default EndOrderModal;
